var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoPremiadoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 27.2C22.185 27.2 27.1994 22.1856 27.1994 16C27.1994 9.81438 22.185 4.79996 15.9994 4.79996C9.81383 4.79996 4.79941 9.81438 4.79941 16C4.79941 22.1856 9.81383 27.2 15.9994 27.2ZM15.9994 29.6C23.5105 29.6 29.5994 23.511 29.5994 16C29.5994 8.48889 23.5105 2.39996 15.9994 2.39996C8.48834 2.39996 2.39941 8.48889 2.39941 16C2.39941 23.511 8.48834 29.6 15.9994 29.6Z",
    fill: "#2B363B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5994 9.6C17.5994 10.4837 16.8831 11.2 15.9994 11.2C15.1158 11.2 14.3994 10.4837 14.3994 9.6C14.3994 8.71634 15.1158 8 15.9994 8C16.8831 8 17.5994 8.71634 17.5994 9.6Z",
    fill: "#2B363B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3994 14.4C14.3994 13.5163 15.1158 12.8 15.9994 12.8C16.8831 12.8 17.5994 13.5163 17.5994 14.4V22.4C17.5994 23.2837 16.8831 24 15.9994 24C15.1158 24 14.3994 23.2837 14.3994 22.4V14.4Z",
    fill: "#2B363B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPremiadoIcon);
export default __webpack_public_path__ + "static/media/info-premiado-icon.4659075a523fcac4c15757223a222abb.svg";
export { ForwardRef as ReactComponent };